import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueMoment from "vue-moment";
import "vue-toastification/dist/index.css";
import adminRouter from "./router/admin";
import superAdminRouter from "./router/super-admin";
import commonRouter from "./router/common";
import store from "./store";

import App from "./App.vue";
import { permissionAbility, formatDate } from "@/helpers/helpers";

// To show toaster
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";

// Pusher
import { pusherChannel, pusherAppKey } from "../pusher-config.js";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";

// helpers
import axios from "@/helpers/axios";
import VueExcelXlsx from "vue-excel-xlsx";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(() => console.log("Firebase Messaging Service Worker registered"));
}

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

Vue.use(VueExcelXlsx);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// global filter
// time formatter
Vue.use(VueMoment);

// global axios
Vue.prototype.$api = axios;
// permissionAbility
Vue.prototype.$permissionAbility = permissionAbility;
Vue.prototype.formatDate = formatDate;

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

const Pusher = require("pusher-js");

const pusher = new Pusher(pusherAppKey, {
  cluster: "ap2",
});

const channel = pusher.subscribe(pusherChannel);

const user = store.getters["userModule/getUser"];

channel.bind("notification-" + user?.id, function (data) {
  let incomingNotificationCount =
    store.getters["userModule/getIncomingNotificationCount"];

  incomingNotificationCount++;

  store.dispatch("userModule/setIncomingNotificationCount", {
    incomingNotificationCount,
  });

  Vue.prototype.$toast(
    {
      component: ToastificationContent,
      props: {
        title: "Notification",
        icon: "BellIcon",
        variant: "warning",
        text: `${data?.data?.message}`,
      },
    },
    {
      timeout: 8000,
    },
  );
});

function getRouter() {
  const isSuperAdminAuthenticated =
    store.getters["superAdminAuthModule/getIsAuthenticated"];
  const isAdminAuthenticated = store.getters["authModule/getIsAuthenticated"];

  if (isSuperAdminAuthenticated) {
    return superAdminRouter;
  } else if (isAdminAuthenticated) {
    return adminRouter;
  } else {
    return commonRouter;
  }
}

let router = getRouter();
new Vue({
  router,
  store,

  render: (h) => h(App),
}).$mount("#app");
